"use strict";
import { PrivyProvider } from "@privy-io/react-auth";
import { SmartWalletsProvider } from "@privy-io/react-auth/smart-wallets";
import { PrivyWagmiBridge } from "components/Web3Provider/privy/PrivyWagmiBridge";
import { PRIVY_DEFAULT_CHAIN, PRIVY_SUPPORTED_CHAINS } from "components/Web3Provider/wagmiConfig";
const PRIVY_APP_ID = process.env.REACT_APP_PRIVY_APP_ID?.trim();
const PRIVY_CLIENT_ID = process.env.REACT_APP_PRIVY_CLIENT_ID?.trim();
const PRIVY_WALLET_CONNECT_PROJECT_ID = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID?.trim();
export const PRIVY_ENABLED = Boolean(PRIVY_APP_ID);
export function PrivyAppProvider({ children }) {
  if (!PRIVY_APP_ID) {
    return <>{children}</>;
  }
  return <PrivyProvider
    appId={PRIVY_APP_ID}
    {...PRIVY_CLIENT_ID ? { clientId: PRIVY_CLIENT_ID } : {}}
    config={{
      // Topaz ID login methods: email, Google, or an external wallet (SIWE). All three authenticate
      // into the user's Topaz ID identity (Privy embedded EOA signer + smart contract wallet) — the
      // external-wallet method just uses the wallet to sign in, NOT as the operating account. These
      // are separate from the app's native wallet connectors (injected/WalletConnect/Coinbase/Safe),
      // where a wallet connects directly as a plain EOA with no Topaz ID.
      loginMethods: ["email", "google", "wallet"],
      ...PRIVY_WALLET_CONNECT_PROJECT_ID ? { walletConnectCloudProjectId: PRIVY_WALLET_CONNECT_PROJECT_ID } : {},
      defaultChain: PRIVY_DEFAULT_CHAIN,
      supportedChains: PRIVY_SUPPORTED_CHAINS,
      // 'all-users' (not 'users-without-wallets') so an external-wallet login still provisions a Privy
      // embedded EOA to sign the smart wallet — otherwise wallet-login users would have no SCW signer.
      embeddedWallets: {
        ethereum: { createOnLogin: "all-users" }
      },
      appearance: {
        walletChainType: "ethereum-only",
        theme: "dark",
        accentColor: "#FE3C00",
        walletList: ["detected_ethereum_wallets", "metamask", "wallet_connect"]
      }
    }}
  >
      <SmartWalletsProvider>{children}</SmartWalletsProvider>
    </PrivyProvider>;
}
export function PrivyBridge({ children }) {
  if (!PRIVY_ENABLED) {
    return <>{children}</>;
  }
  return <PrivyWagmiBridge>{children}</PrivyWagmiBridge>;
}
